import axiosInstance from './axiosInstance';

/**
 * Thin verb wrapper over the shared axios instance. Services use this instead
 * of importing axios directly, so the transport can be swapped/extended in one
 * place. Each method returns the parsed `data` payload.
 */
export const httpClient = {
  get: (url, config) => axiosInstance.get(url, config).then((r) => r.data),
  post: (url, body, config) => axiosInstance.post(url, body, config).then((r) => r.data),
  put: (url, body, config) => axiosInstance.put(url, body, config).then((r) => r.data),
  patch: (url, body, config) => axiosInstance.patch(url, body, config).then((r) => r.data),
  delete: (url, config) => axiosInstance.delete(url, config).then((r) => r.data),
};

export default httpClient;
